import React from 'react';
import SolutionInstallmentExaminationChoiceContainer from 'containers/SolutionInstallmentExaminationChoiceContainer/SolutionInstallmentExaminationChoiceContainer';

export default function SolutionInstallmentExaminationChoicePage() {
    return (
        <SolutionInstallmentExaminationChoiceContainer />
    )
}
